import { FC } from "react";
import { useToast } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  Text,
  Button,
} from "@chakra-ui/react";

interface BraveWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueToAppClip: () => void;
}

export const BraveWarningModal: FC<BraveWarningModalProps> = ({
  isOpen,
  onClose,
  onContinueToAppClip,
}) => {
  const toast = useToast();

  const handleCopyLink = () => {
    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        toast({
          title: "Link copied!",
          description: "The link has been copied to your clipboard. Open Safari and paste it.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      })
      .catch(() => {
        toast({
          title: "Failed to copy",
          description: "Please copy the link manually from the address bar.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent width={340}>
        <ModalHeader pt="16px" pb="8px">
          Browser Compatibility Notice
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            <Text fontSize="15px" color="gray.700">
              AppClip linking isn't reliable in Brave browser. We recommend copying the link and
              opening it in Safari for the best experience.
            </Text>

            <VStack spacing={3}>
              <Button
                width="full"
                bg="#007AFF"
                color="white"
                _hover={{ bg: "#0066CC" }}
                _active={{ bg: "#0055AA" }}
                borderRadius="12px"
                height="44px"
                onClick={handleCopyLink}
              >
                Copy Link to Safari
              </Button>

              <Button
                width="full"
                bg="gray.200"
                color="black"
                _hover={{ bg: "gray.300" }}
                _active={{ bg: "gray.400" }}
                borderRadius="12px"
                height="44px"
                onClick={() => {
                  onClose();
                  onContinueToAppClip();
                }}
              >
                Continue in AppClip Anyway
              </Button>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
